import { z } from 'zod';

export const PHONE_REGEX = /^\(\d{3}\) \d{3}-\d{4}$/;
export const SSN_REGEX = /^\d{3}-\d{2}-\d{4}$/;

export const validationMessages = {
  email: 'Invalid email (e.g. example@mail.com)',
  phone: 'Invalid phone format (e.g. (555) 123-4567)',
  ssn: 'Invalid SSN (e.g. 123-45-6789)',
} as const;

export const emailSchema = z.string().email(validationMessages.email).trim().toLowerCase();

export const phoneSchema = z.string().trim().regex(PHONE_REGEX, validationMessages.phone);

export const ssnSchema = z.string().trim().regex(SSN_REGEX, validationMessages.ssn);
